import * as React from 'react';

import { Button, Typography } from '@mui/material';
import { chevronRightIcon, FaOptionIcon } from '@europrocurement/l2d-icons';

export type DetailsViewEditButtonProps = {
    label: string;
    href?: string;
    openInNewTab?: boolean;
};

export const DetailsViewEditButton: React.FunctionComponent<DetailsViewEditButtonProps> =
    function ({ label, href = '', openInNewTab = false }) {
        return (
            <Button
                role="button"
                href={href}
                target={openInNewTab ? '_blank' : undefined}
                rel={openInNewTab ? 'noopener noreferrer' : undefined}
                variant="text"
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                }}
            >
                <Typography
                    sx={{ marginLeft: '5px' }}
                    variant="l2dbodys"
                    color="primary.dark"
                >
                    {label}
                </Typography>
                <FaOptionIcon
                    {...chevronRightIcon.props}
                    color="primary.dark"
                    size="xs"
                />
            </Button>
        );
    };
